export const MAINNET_CONTRACTS = {
  app: "0x1eFA8F82d9E919F6b6A5f1701131c9Cb1a943BAA",
  defaultToken: "0x6bDc36E20D267Ff0dd6097799f82e78907105e2F"
} as const;

export const TESTNET_CONTRACTS = {
  app: "0x688419B0299f3Ed8E80eBCa71ad05Ac23d20822b",
  defaultToken: "0xeee5a340Cdc9c179Db25dea45AcfD5FE8d4d3eB8"
} as const;
